module.exports = __webpack_public_path__ + "static/promlens-logo-with-text-b4c642a80f8c73211071963463ed08bd.svg";